import styles from "./StatsCard.module.css";

export default function StatsCard({ label, value, delta, ghost, accent = false }) {
  return (
    <article className={`${styles.card} ${accent ? styles.accent : ""}`}>
      <span className={styles.ghost} aria-hidden="true">{ghost}</span>
      <span className={styles.delta}>{delta}</span>
      <p className={styles.label}>{label}</p>
      <p className={styles.value}>{value}</p>
    </article>
  );
}
